<ng-container *transloco="let t">
  @if (displayItemQuantities()) {
    <pxw-counter [(count)]="productQuantity" [max]="maxQuantity()" />
  }
  <pxw-button
    class="submit-button"
    mode="submit"
    [formId]="formId()"
    color="yellow"
    size="lg"
    [rounded]="true"
    [disabled]="disabled() || hasStockIssues()"
  >
    <span class="add-product-label">{{ buttonText() }}</span>
    <pxw-product-price
      [price]="cartItemSubtotal()"
      [priceDiscount]="cartItemSubtotalWithDiscount()"
      layout="product-detail"
    />
  </pxw-button>
</ng-container>
